//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.KPredaniVsemListPage.ts              </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-01-04                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class KPredaniVsemListPage extends GContentBase<PodDokSpisListBasePage>
    {
        model: Wfl.Interface.GRedistribuceKPredaniFilterDto;

        onContentReady() {
            var that = this;
            PodDokSpisListBasePage.InitList(this);
            this.topActions.push(Wfl.ListAC.WflListBaseAC.CreateActionDetailDokSpis(this));
            this.specialActions.push(Wfl.ListAC.DokSpisListBaseAC.CreateActionPredat(this, true));
            this.specialActions.push(Gordic.Wfl.ListAC.DokSpisListBaseAC.CreateActionPridelit(this, true, true));
            this.specialActions.push(Gordic.Wfl.ListAC.DokSpisListBaseAC.CreateActionZrusitPrideleni(this, true));
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    favorites: "all",
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_dsred" }),
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky"
                })

            Wfl.ListAC.DokSpisListBaseAC.CreateGridDokSpis(this);
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni)
        }

        CreateFilterForms() {
            var that = this;
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }); //RC 26285623 : Filtr balíků
            filterForm.addSection("");
            filterForm.addRow({ label: "" }).addField("gradio", {
                name: "TypSubjektu", itemClass: "",
                initialValue: this.model.TypSubjektu,
                radios: [
                    { value: Gin.Interface.IxsType.IxsSu, label: 'jres:23900149' }, //RC 23900149 : na uzel
                    { value: Gin.Interface.IxsType.IxsFun, label: 'jres:23900150' }, //RC 23900150 : osobě
                ],
                change: function (event, input) {
                    //if (input.value) {
                    //    if (that.defaultForm) {
                    //        that.defaultForm.findFields(fieldNames.referent).gfield("option", "disabled", input.value != 1);
                    //        that.defaultForm.findFields(fieldNames.extSubject).gfield("option", "disabled", input.value == 1);
                    //    }
                    //}
                }
            });
            filterForm.addRow("jres:23900226") //RC 23900226 : Přebírající
            filterForm.addField("gselectbox", 
                Gordic.Gin.Fields.ginspodSSU(
                        {
                            name: "suField",
                            model: "model.Prebirajici.ixs_su = ixs_su",
                            serverFilters: {
                                aktivita: [100],
                        },
                        change: function (ev, data) {
                            if (data && data.value)
                            {
                                that.IxsSuOperation = data.value.ixs_su;
                            }
                        }
                        }, false))

                .addField("gselectbox", 
                    Gordic.Gin.Fields.ginsfunSSU(
                        {
                            name: "funField",
                            model: "model.Prebirajici.ixs_fun = ixs_fun",
                            serverFilters: {
                                aktivita: [100],
                                ixs_su: new Gordic.Forms.Dependency("suField", "ixs_su")
                            },
                            change: function (ev, data)
                            {
                                if (data && data.value)
                                {
                                    that.IxsFunOperation = data.value.ixs_fun;
                                    that.IxsSuOperation = data.value.ixs_su;
                                }
                            }
                        }, false, "suField"))

            return [filterForm];
        }

        LoadData(filtr?: Wfl.Interface.GRedistribuceKPredaniFilterDto) {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            this.model = $.extend({}, this.model, filtr);
            if (this.model) {
                var that = this;
                Gin.Globals.ShowWaitLoadData(this);
                //nacteni dat do gridu
                this.call<Wfl.Interface.DokSpisListDto[]>("LoadData", { "model": this.model })
                    .done(function (data) {
                        var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                        that.mainGrid.ggrid("setData", view);
                        that.IxsSuOperation = that.model.Prebirajici.ixs_su;
                        that.IxsFunOperation = that.model.Prebirajici.ixs_fun;
                    })
                    .always(function () { Gordic.Wfl.ListAC.DokSpisListBaseAC.AfterLoadData(that); });
            }
        }

        ReloadData() {
            this.LoadData(this.model);
        }
    }
};
